import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  loading: { height: '100vh' },
  chevron: {
    marginTop: theme.spacing(1)
  },
  container: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3),
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
  },
  image: {
    width: '100%'
  },
  pushRight: {
    marginRight: theme.spacing(2)
  },
  genre: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  title: {
    marginBottom: theme.spacing(2)
  },
  checkboxYes: {
    color: theme.palette.success.main
  },
  checkboxNo: {
    color: theme.palette.error.main
  }
}))